<template>
  <div class="ph-shade" v-if="display" @click="tap"></div>
</template>

<script>
export default {
  name: 'coverpanel',
  props: {
    display: false
  },
  methods: {
    tap () {
      this.$emit('tap');
    }
  }
}
</script>

<style lang="less" scoped>
.ph-shade {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  z-index: 1000;
  background: #000;
  opacity: 0.7;
  overflow: hidden;
}
</style>


